<template>
  <b-nav v-if="navPermissions['portalAdmin'].enable">
    <b-nav-item-dropdown
        id="my-nav-dropdown "
        text="Portal Administration"
        toggle-class="nav-link-custom"
    >
      <template slot="button-content">
        <i class="fa mr-2 fa-lock text-blue" font-scale="1"></i>
        <span>Administration</span>
      </template>

      <b-dropdown-item to="/admin/user_admin">
        <i class="fa fa-user text-danger pr-2"></i>
        <span class="nav-link-text">User Management</span>
      </b-dropdown-item>

      <b-dropdown-item v-if="hasNsim" to="/admin/product_management">
        <i class="fa fa-archive text-cyan pr-2"></i>
        <span class="nav-link-text">Product Management</span>
      </b-dropdown-item>

<!--      <b-dropdown-item-->
<!--          v-if="isPortalAdminStatus"-->
<!--          to="/admin/simtool">-->
<!--        <i class="fa fa-magnet text-orange" font-scale="1"></i>-->
<!--        Sim Tool-->
<!--      </b-dropdown-item>-->

    </b-nav-item-dropdown>
  </b-nav>
</template>
<script>
import initService from "@/common/api-services/init-service";
import configDirective from "../../../common/directive/config-directive";

export default {
  name: 'top-admin-basic-group',
  components: {},

  data() {
    return {
      isPortalAdminStatus: false,
      isAdminStatus: false,
      groups: [],
      hasNsim: false,

      adminCollaps: false,
      link: {
        name: '',
        icon: '',
        path: '',
        children: []
      },

      navPermissions: {
        "portalAdmin": {
          enable: false,
          role: ["Administrator"],
          data: {
            "adminAccess": {
              enable: false,
              role: ["Administrator"]
            },
          }
        }
      }
    }
  },

  mounted() {
    this.isPortalAdminStatus = initService.getPortalAdminRole();
    this.isAdminStatus = initService.getAdministratorRole() || initService.getPortalAdminRole();
    this.groups = initService.getGroups();
    this.hasNsim = configDirective.hasNsim();
    Object.keys(this.navPermissions).map(item => {
      this.groups.map(it => {
        if (this.navPermissions[item].role.includes(it)) this.navPermissions[item].enable = true;
      });
    });
  }
}
</script>